export function rxsecret() {
  let result = []
  result.web_port = 3388

  result.base_api = 'https://api.bobacu.io'
  result.socket_api = 'https://socket.bobacu.io'
  result.profile_api = 'https://minio.bobacu.io'
  result.cdn_endpoint = 'https://minio.bobacu.io/profiles/'
  result.meet_endpoint = 'meet.bobacu.io'
  result.application_id = 17
  result.auth_key = 'B2D89AC8B8ECF'
  result.nonce = 92101
  result.signature = 'a94f05d87c7e10499fc480858fc638070f9ee2fc'
  result.timestamp = 1636595408
  result.theme = 'default'


  return result
}
